import { Badge } from '@/components/ui/Badge'
import { STATUS_CONFIG } from '@/lib/utils/booking'
import type { BookingStatus } from '@/lib/types/booking'

interface BookingStatusBadgeProps {
  status: BookingStatus
}

const variantMap: Record<string, 'amber' | 'green' | 'red' | 'blue' | 'violet' | 'default'> = {
  request: 'amber',
  approved: 'green',
  arrived: 'blue',
  in_delivery: 'violet',
  seated: 'violet',
  left: 'default',
  no_show: 'red',
  canceled: 'red',
  waitlist: 'amber',
}

export function BookingStatusBadge({ status }: BookingStatusBadgeProps) {
  const config = STATUS_CONFIG[status]
  return <Badge variant={variantMap[status] ?? 'default'}>{config.label}</Badge>
}
